import {CommonModule} from '@angular/common';
import {NgModule} from '@angular/core';
import {MatIconModule} from '@angular/material/icon';
import {MatMenuModule} from '@angular/material/menu';
import {MatProgressSpinnerModule} from '@angular/material/progress-spinner';
import {MatTooltipModule} from '@angular/material/tooltip';
import {OphButtonModule} from '../design/oph-button/oph-button.module';
import {OphIconModule} from '../design/oph-icon/oph-icon.module';
import {PipesModule} from '../pipes/pipes.module';
import {CurrentSkedCheckboxComponent} from './checkbox/current-sked-checkbox.component';
import {CurrentSkedDetailDefaultTaskViewActionButtonsComponent} from './legacy/action-buttons/current-sked-detail-default-task-view-action-buttons.component';
import {CurrentSkedSelectorComponent} from './legacy/selector/current-sked-selector.component';
import {CurrentSkedTaskProgressComponent} from './task-progress/current-sked-task-progress.component';

@NgModule({
  declarations: [
    CurrentSkedTaskProgressComponent,
    CurrentSkedCheckboxComponent,
    CurrentSkedDetailDefaultTaskViewActionButtonsComponent,
    CurrentSkedSelectorComponent,
  ],
  imports: [
    CommonModule,
    MatMenuModule,
    PipesModule,
    OphIconModule,
    MatProgressSpinnerModule,
    MatIconModule,
    MatTooltipModule,
    OphButtonModule,
  ],
  exports: [
    CurrentSkedTaskProgressComponent,
    CurrentSkedCheckboxComponent,
    CurrentSkedDetailDefaultTaskViewActionButtonsComponent,
    CurrentSkedSelectorComponent,
  ],
})
export class SharedCurrentSkedModule {}
